import { render } from "./dashboardManager.vue?vue&type=template&id=6557f6d0&ts=true"
import script from "./dashboardManager.vue?vue&type=script&lang=ts"
export * from "./dashboardManager.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__